<template>
    <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg" :class="className">
        <g opacity="1">
            <path fill-rule="evenodd" clip-rule="evenodd" d="M4 8C3.44771 8 3 8.44771 3 9V14C3 16.2091 4.79087 18 7 18H13C15.2091 18 17 16.2091 17 14V9C17 8.44771 16.5523 8 16 8H4ZM1 9C1 7.34315 2.34315 6 4 6H16C17.6569 6 19 7.34315 19 9V14C19 17.3137 16.3137 20 13 20H7C3.68629 20 1 17.3137 1 14V9Z" fill="#858E97"/>
            <path fill-rule="evenodd" clip-rule="evenodd" d="M4 6C4 2.6863 6.6863 0 10 0C13.3137 0 16 2.68629 16 6V7H14V6C14 3.79087 12.2091 2 10 2C7.79086 2 6 3.79086 6 6V7H4V6Z" fill="#858E97"/>
            <path d="M6 12C6.55228 12 7 11.5523 7 11C7 10.4477 6.55228 10 6 10C5.44772 10 5 10.4477 5 11C5 11.5523 5.44772 12 6 12Z" fill="#858E97"/>
            <path d="M14 12C14.5523 12 15 11.5523 15 11C15 10.4477 14.5523 10 14 10C13.4477 10 13 10.4477 13 11C13 11.5523 13.4477 12 14 12Z" fill="#858E97"/>
        </g>
    </svg>
</template>

<script>
export default {
    name: 'IconLock',

    props: ['className']
};
</script>

<style lang="scss">
@import "Icons";
</style>
